/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaNotificationBadge/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaNotificationBadge({
  children,
  viewPath = "/DesignSystem/TysiaNotificationBadge",
  backgroundColor = "TysiaNotificationBadge.backgroundColor.primary.base",
  marginTop = 0,
  marginLeft = 0,
  marginRight = 0,
  position,
  top,
  right,
  bottom,
  left,
  color,
  fontSize,
  text
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtTysianotificationbadgeFontsizeBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaNotificationBadge.fontSize.base'
        })
let dtTysianotificationbadgeColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaNotificationBadge.color.primary.base'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaNotificationBadge.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z2o2gNR': backgroundColor,'--bblr-2-Z2o2gNR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-Z2o2gNR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-Z2o2gNR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-Z2o2gNR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-6-Z2o2gNR': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ml-7-Z2o2gNR': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-8-Z2o2gNR': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--p-9-Z2o2gNR': position,'--t-10-Z2o2gNR': typeof top === 'number' ? `${top}px` : top,'--r-11-Z2o2gNR': typeof right === 'number' ? `${right}px` : right,'--b-12-Z2o2gNR': typeof bottom === 'number' ? `${bottom}px` : bottom,'--l-13-Z2o2gNR': typeof left === 'number' ? `${left}px` : left,'--c-14-Z2o2gNR': color,'--fs-15-Z2o2gNR': typeof fontSize === 'number' ? `${fontSize}px` : fontSize}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={fontSize || dtTysianotificationbadgeFontsizeBase}
 color={color || dtTysianotificationbadgeColorPrimaryBase}
 textAlign="center"
 text={text}
/>
</div>
{children}
</React.Fragment>)
}